/* Reopen Shopify's native preferences; never write consent from this control. */
(() => {
  if (window.tdtFooterPolicies) return;
  window.tdtFooterPolicies = true;
  const available = () => typeof window.privacyBanner?.showPreferences === 'function';
  const update = () => document.querySelectorAll('.tdt-ft__cookie-item').forEach(item => { item.hidden = !available(); });
  document.addEventListener('click', event => {
    const button = event.target.closest?.('.tdt-ft__cookie-preferences');
    if (!button || !available()) return;
    Promise.resolve(window.privacyBanner.showPreferences()).catch(() => { button.closest('li').hidden = true; });
  });
  update();
  let attempts = 0;
  const readyTimer = window.setInterval(() => {
    update();
    if (available() || ++attempts >= 20) window.clearInterval(readyTimer);
  }, 500);
  window.addEventListener('pagehide', () => window.clearInterval(readyTimer), { once: true });
  window.addEventListener('load', update, { once: true });
  document.addEventListener('shopify:section:load', update);
  document.addEventListener('visitorConsentCollected', update);
})();
